import BlockContainer from "../components/BlockContainer";
import { TextForm } from "../components/FormItem";
import { useContext, useEffect, useMemo, useRef, useState } from "react";
import { Button, Col, Form, Row, Modal, Spinner, Image } from "react-bootstrap";
import { ICON_LOGIN_FORGOT, ICON_LOGIN_REGISTER, ICON_LOGIN_SIGNIN } from "../components/icons";
import { PageContext, PAGE_REGISTER } from "../contexts/PageContext";
import { SendResetPassword } from "../databases/auth";
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "../config/firebase";



const PageSignin = () => {
    const dragonRef = useRef(null)

    const [dragonModal, setDragonModal] = useState(false);
    const [dragonState, setDragonState] = useState(0);
    const [mUserName, setUserName] = useState('')
    const [mPassword, setPassword] = useState('')
    const [acceptPDPA, setAcceptPDPA] = useState(false)
    const [onLoading, setOnLoading] = useState(false)

    const { setPage } = useContext(PageContext)

    useEffect(() => {
        return () => {
            setDragonModal(false)
            setDragonState(0)
            setUserName('')
            setPassword('')
            setAcceptPDPA(false)
            setOnLoading(false)
        }
    }, [])

    const onForgotPassword = async () => {
        if (!mUserName) alert('โปรดใส่อีเมลของท่าน')
        else {
            await SendResetPassword(mUserName)
                .then(() => alert(`ส่งอีเมลรีเซ็ตรหัสผ่านไปที่ ${mUserName} แล้ว โปรดตรวจสอบอีเมลของท่าน`))
                .catch(e => alert('เกิดข้อผิดพลาด'))
        }
    }

    const onSubmit = async () => {
        try {
            setOnLoading(true)
            await signInWithEmailAndPassword(auth, mUserName, mPassword)
            //alert('ขออภัย ปิดปรับปรุงชั่วคราว')
        }
        catch (e) {
            switch (e.code) {
                case 'auth/user-not-found':
                    alert(`ขออภัย ไม่พบอีเมล ${mUserName} โปรดตรวจสอบอีเมลอีกครั้ง`);
                    break;
                case 'auth/wrong-password':
                    alert(`ขออภัย รหัสผ่านผิด`);
                    break;
                case 'auth/too-many-requests':
                    alert(`ขออภัย กรุณารอสักครู่`);
                    break;
                case 'auth/network-request-failed':
                    alert(`ขออภัย โปรดตรวจสอบเครือข่ายของท่าน หากท่านอยู่ในประเทศจีน โปรดเชื่อมต่อ vpn`);
                    break;
                default:
                    if (e.message.indexOf('(') !== -1 && e.message.indexOf(')') !== -1 ) {
                        let err = e.message.replace('(', '|').replace(')', '|').split('|')
                        alert(err[1])
                    }
                    else {
                        alert(e.message)
                    }
                  break;
              }
        }
        finally {
            setOnLoading(false)
        }
        
    }

    useEffect(() => {
        if (dragonModal) setDragonState(0)
    }, [dragonModal])

    const DragonContent = useMemo(() => {
        switch (dragonState) {
            case 0: default :
                return (
                    <div>
                        <div> - ฉันจะอ่าน <a rel="noreferrer" href={`https://drive.google.com/file/d/1ur3xi1EI9xw2DIek6EBxoJtuBCPFDErj/view`} target='_blank'>คู่มือ #พาเด็กไทยกลับจีน</a></div>
                        <hr />
                        <div> - ฉันจะอ่าน <a rel="noreferrer" href={`https://29094349.s21i.faiusr.com/61/ABUIABA9GAAg-onnlwYokOvTogE.pdf?utm_source=Social&utm_medium=Organic&utm_campaign=Manual`} target='_blank'>สารพัดเรื่องแดนมังกร</a></div>
                        <hr />
                        <div> - <span className="link-style" onClick={() => setDragonState(5)}> ฉันจะมีบัญชีคุณมังกรได้อย่างไร </span></div>
                        <hr />
                        <div> - <span className="link-style" onClick={() => setDragonState(6)}> ฉันคิดว่าฉันใส่อีเมลถูกแล้ว แต่เข้าไม่ได้ ทำอย่างไรดีคุณมังกร </span></div>
                        <hr />
                        <div> - <span className="link-style" onClick={() => setDragonState(1)}> ฉันจำอีเมลไม่ได้ ทำอย่างไรดีคุณมังกร </span></div>
                        <hr />
                        <div> - <span className="link-style" onClick={() => setDragonState(2)}> ฉันลืมรหัสผ่าน ทำอย่างไรดีคุณมังกร </span></div>
                        <hr />
                        <div> - <span className="link-style" onClick={() => setDragonState(3)}> ฉันใส่ไฟล์แล้ว กดรีเฟรช ทำไมรูปหายล่ะคุณมังกร </span></div>
                        <hr />
                        <div> - <span className="link-style" onClick={() => setDragonState(4)}> ฉันแก้ไขข้อมูลแล้ว ทำไมคุณมังกรไม่เปลี่ยนให้ฉัน </span></div>
                        <hr />
                    </div>
                )
            case 1 :
                return <div>ติดต่อทีมงานได้เลย!</div>
            case 2 :
                return <div>ลองใส่อีเมล แล้วคลิกปุ่ม " ลืมรหัสผ่าน " ดูสิ จากนั้นลองเช็คอีเมล และใส่รหัสผ่านได้เลย!</div>
            case 3 :
                return <div>กดปุ่มรูปลูกศรขึ้น ที่อยู่ขวามือของช่องใส่รูปให้คุณมังกรหน่อยสิ!</div>
            case 4 :
                return <div>กดปุ่ม " บันทึก " สีเขียวที่อยู่บนสุดให้คุณมังกรหน่อยสิ!</div>
            case 5 :
                return <div>ลงทะเบียนกลับจีนกับ ทีมงาน #พาเด็กไทยกลับจีน ได้เลย</div>
            case 6 :
                return <div>ลองกลับไปดูกูเกิลฟอร์มที่ส่งกลับมาในอีเมลดูสิ ทางเราจะใช้อีเมลนั้นลงทะเบียนให้คุณ</div>
        }
        
    }, [dragonState])

    


    return (
        <BlockContainer>
            <Modal show={dragonModal} size='md' onHide={() => setDragonModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>สวัสดี! มีอะไรให้ช่วยไหม ?</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {DragonContent}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="danger" onClick={() => setDragonModal(false)}>{dragonState ? 'ฉันเข้าใจแล้ว' : 'บาย'}</Button>
                </Modal.Footer>
            </Modal>
            <Row>
                <Col sm={12} md={4} >
                    <div 
                        className="text-center" style={{marginTop : '-20px', marginLeft : '-20px', cursor : 'pointer'}} 
                        ref={dragonRef} 
                        onMouseEnter={() => dragonRef.current.style.background = '#ffbb96'}
                        onMouseLeave={() => dragonRef.current.style.background = 'white'}
                        onClick={() => setDragonModal(true)}
                    >
                        <Image alt="" src='./images/DMK_LOGO.png' height={300} />
                    </div>
                </Col>
                <Col sm={12} md={8}>
                    <TextForm title='อีเมล' value={mUserName} onChange={e => setUserName(e.target.value)} />
                    <TextForm type='password' title='รหัสผ่าน' value={mPassword} onChange={e => setPassword(e.target.value)} />
                    <Form.Check 
                        checked={acceptPDPA} label={<div>ข้าพเจ้ายอมรับ<a href='./pdf/นโยบายการคุ้มครองข้อมูลส่วนบุคคล.pdf'>นโยบายการคุ้มครองข้อมูลส่วนบุคคล</a> (Privacy Policy)</div>} name={`form-check-pdpa2`} id={`form-check-pdpa2`}
                        onChange={e => setAcceptPDPA(e.target.checked)} 
                    />
                    <br />
                    <Row bsPrefix="row text-center d-none d-sm-flex">
                        <Col><Button variant="danger" onClick={onForgotPassword}>{ICON_LOGIN_FORGOT} ลืมรหัสผ่าน</Button></Col>
                        <Col><Button variant="light" onClick={() => setPage(PAGE_REGISTER)}>{ICON_LOGIN_REGISTER} สร้างบัญชี</Button></Col>
                        <Col><Button disabled={!acceptPDPA || onLoading} onClick={onSubmit}>{<Spinner animation="border" hidden={!onLoading} size='sm'/>} {ICON_LOGIN_SIGNIN} เข้าสู่ระบบ</Button></Col>
                    </Row>
                    <div className="text-center d-sm-none">
                        <Button style={{width : '90%'}} disabled={!acceptPDPA || onLoading} onClick={onSubmit}>
                            {<Spinner animation="border" hidden={!onLoading} size='sm'/>} {ICON_LOGIN_SIGNIN} เข้าสู่ระบบ
                        </Button>
                        <br /><br />
                        <Button style={{width : '90%'}} variant="light" onClick={() => setPage(PAGE_REGISTER)}>{ICON_LOGIN_REGISTER} สร้างบัญชี</Button>
                        <br /><br />
                        <Button variant="danger" style={{width : '90%'}} onClick={onForgotPassword}>{ICON_LOGIN_FORGOT} ลืมรหัสผ่าน</Button>
                    </div>
                    
                </Col>
                
                
            </Row>
        </BlockContainer>
    )
}

export default PageSignin;